export interface Earning {
  id: string;
  token: string;
  title: string;
  artist: string;
  state: string;
  price: number;
  splitAddress: string;
  splitPercent: number;
  splitBalance: string;
}

export const myNFT = [
  "Title",
  "Artists",
  "Status",
  "Opensea Link",
  "Sale Price",
  "My Earnings",
];

export type NftTableProps = {
  title: string;
  handleSort: () => void;
  earnings: Earning[];
  columns: string[];
  etherscanURL: string;
};


export type WalletDetailsProps = {
  connectedWallet: string | undefined;
  wBalance: string;
  isWithdrawing: boolean;
  withdrawBalance: () => Promise<void>;
};